import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const PlaySvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18.125 11.7835C18.2917 11.8797 18.2917 12.1203 18.125 12.2165L9.875 16.9796C9.70833 17.0759 9.5 16.9556 9.5 16.7631L9.5 7.23686C9.5 7.04441 9.70833 6.92413 9.875 7.02035L18.125 11.7835Z'
      fill='currentColor'
    />
    <circle cx='12.5' cy='12' r='9.75' stroke='currentColor' strokeWidth='0.5' />
  </svg>
);

export const PlayIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PlaySvg} color='white' {...props} />
);
